import React, { Component } from 'react';
import { Jumbotron } from 'reactstrap';

export class Home extends Component {
  static displayName = Home.name;

  componentDidMount = () => {

  }

  render () {
    return (
        <div>
        <Jumbotron className="text-center">
          <img src="images/fliway-logo.png" alt=""/>
          <hr className="my-2" />
          <p className="lead">Welcome to the Fliway Home Delivery App.<br/>What would you like to do?</p>
          <hr className="my-2" />
        </Jumbotron>
      </div>
    );
  }
}
